import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Form, Message } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ProposalReviseForm from '../../components/forms/proposalReviseForm/ProposalReviseForm'
import { saveReviewFeedback } from '../../redux/actions/reviewerFeedback'
import pathname from '../../constants/pathname'
import { useParams, useHistory } from 'react-router-dom'
import { startLoading, doneLoading } from '../../utils/loading'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function SendBackToFix(props) {
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isLoading, setIsLoading] = useState()
  const [isError, setIsError] = useState()
  const [isShowConfirmModal, setIsShowConfimModal] = useState(false)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  // const projectId = '9BE3B891-FD65-416B-8459-7AD624B5D3F2'
  let history = useHistory()

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await saveReviewFeedback(projectId, request)
      setIsLoading(false)
      doneLoading()
      return history.push(`${pathname.proposal.overview.overviewCoworker}`)
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    setIsShowConfimModal(true)
  }

  const handleOnConfirmModal = (data) => {
    let request = []
    data.requestBody?.forEach((revise) => {
      revise.subItems.forEach((subRevise) => {
        if (subRevise.subItems && subRevise.subItems.length > 0) {
          subRevise.subItems.forEach((item) => {
            request.push(item)
          })
        } else {
          request.push(subRevise)
        }
      })
    })
    setIsShowConfimModal(false)
    handleCallService(request)
  }

  return (
    <>
      <Form fluid>
        <Panel shaded header="" bordered collapsible defaultExpanded>
          <ProposalReviseForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
          <hr />
          {isError && (
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <Message showIcon type="error" description={`ส่งกลับผู้ขอรับทุนไม่สำเร็จ`} />
            </div>
          )}
          <SaveButton onClick={handleSubmit(onSubmit)}>ส่งกลับผู้ขอรับทุน</SaveButton>
        </Panel>
        <br />
      </Form>
      <ConfirmWidget
        title={'ยืนยันการส่งกลับแก้ไข'}
        show={isShowConfirmModal}
        detail={`กรุณายืนยันการส่งกลับแก้ไข`}
        onCancle={() => setIsShowConfimModal(false)}
        onConfirm={handleSubmit(handleOnConfirmModal)}
      />
    </>
  )
}
